module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-settings/141assets/fonts/ed9ac9f59a603e21e295262b23621bad.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 756
// module chunks = 4